import {
    spaceMicro,
    spaceSmall,
    spaceRegular,
    fontMicro,
    fontHuge,
} from '@ui/styles/spaces';
import {
    azurColor,
    pureWhite,
    darkMarineColor,
    lightMarineColor,
    lighterMarineColor,
    greyColor,
    lightGreyColor,
} from '@ui/styles/colors';

const iconStyle = {
    '& .MuiSvgIcon-root': {
        borderRadius : '50%',
        transform    : 'scale(1.22)',
    },

    '& .MuiIconButton-label': {
        backgroundColor : pureWhite,
        borderRadius    : '50%',
    },
};

export const boxCompositionCardStyle = {
    width          : '100%',
    flexBasis      : '100%',
    maxWidth       : '100%',
    display        : 'flex',
    flexDirection  : 'column' as 'column',
    justifyContent : 'flex-start' as 'flex-start',
    alignItems     : 'center' as 'center',
    textAlign      : 'left' as 'left',
    flexGrow       : 1,
    alignSelf      : 'stretch',
    textDecoration : 'none',
    color          : darkMarineColor,
    marginBottom   : spaceSmall,
};

export const boxCompositionCardCol2Style = {
    ...boxCompositionCardStyle,
    width     : `calc((100% - ${spaceSmall}px) / 2)`,
    flexBasis : `calc((100% - ${spaceSmall}px) / 2)`,
    maxWidth  : `calc((100% - ${spaceSmall}px) / 2)`,
};

export const boxCompositionCardContentStyle = {
    padding: 0,
};

export const boxCompositionCardActionAreaStyle = {
    flexGrow       : 1,
    display        : 'flex',
    flexDirection  : 'column' as 'column',
    justifyContent : 'stretch' as 'stretch',
    alignItems     : 'stretch' as 'stretch',
    padding        : spaceSmall,
    position       : 'relative' as 'relative',
};

export const boxCompositionMediaStyle = {
    display         : 'flex',
    flexDirection   : 'column' as 'column',
    justifyContent  : 'center' as 'center',
    alignItems      : 'center' as 'center',
    width           : '100%',
    height          : 200,
    objectFit       : 'cover' as 'cover',
    objectPosition  : '50% 50%',
    borderRadius    : spaceMicro,
    backgroundColor : pureWhite,
};

export const boxCompositionMediaCol2Style = {
    ...boxCompositionMediaStyle,
    height: 120,
};

export const boxCompositionTitleStyle = {};

export const boxCompositionSubtitleStyle = {
    marginTop  : spaceMicro,
    lineHeight : 1,
    color      : lighterMarineColor,
};

export const wrapperBoxEuroIconStyle = {
    display: 'flex',
};

export const wrapperBoxInfoIconStyle = {
    ...iconStyle,
    position : 'absolute' as 'absolute',
    top      : 0,
    right    : 0,
    padding  : spaceRegular,
    zIndex   : 3,
};

export const boxInfoIconStyle = {
    color: lightMarineColor,
};

export const loadMoreIconStyle = {
    color    : lightMarineColor,
    fontSize : fontHuge,
};

export const modalContainerStyle = {
    display        : 'flex',
    flexDirection  : 'column' as 'column',
    justifyContent : 'center' as 'center',
    outline        : 'none',
    boxSizing      : 'border-box' as 'border-box',
};

export const modalContainerStyleFullHeight = {
    modalContainerStyle,
    height    : 'calc(var(--vh, 1vh) * 100)',
    boxSizing : 'border-box' as 'border-box',
};

export const modalCardStyle = {
    position        : 'relative' as 'relative',
    justifyContent  : 'center' as 'center',
    alignItems      : 'center' as 'center',
    maxHeight       : 'calc(var(--vh, 1vh) * 100)',
    backgroundColor : lightGreyColor,
    padding         : 0,
    boxSizing       : 'border-box' as 'border-box',
};

export const modalCardStyleFullHeight = {
    ...modalCardStyle,
    height    : 'calc(var(--vh, 1vh) * 100)',
    boxSizing : 'border-box' as 'border-box',
};

export const getStyledHeaderActionStyle = {
    padding      : 0,
    marginTop    : spaceSmall,
    marginBottom : 0,
    flexGrow     : 1,
    boxSizing    : 'border-box' as 'border-box',

    '& .MuiCardHeader-action': {
        marginRight    : 0,
        marginTop      : 0,
        flexDirection  : 'column' as 'column',
        justifyContent : 'space-between' as 'space-between',
        alignSelf      : 'flex-start' as 'flex-start',
    },

    '& .MuiCardHeader-content': {
        marginRight    : 0,
        marginTop      : 0,
        flexDirection  : 'column' as 'column',
        justifyContent : 'space-between' as 'space-between',
        alignSelf      : 'flex-start' as 'flex-start',
        paddingRight   : 8,
    },
};

export const indicatorIconsStyle = {
    fontSize : fontMicro,
    color    : lighterMarineColor,
    width    : 12,
};

export const indicatorEcoIconsActiveStyle = {
    ...indicatorIconsStyle,
    color: lightMarineColor,
};

export const indicatorPriceIconsActiveStyle = {
    ...indicatorIconsStyle,
    color: lightMarineColor,
};

export const moreInfoCardContentStyle = {
    display        : 'flex',
    flexDirection  : 'column' as 'column',
    justifyContent : 'center' as 'center',
    alignItems     : 'center' as 'center',
};

export const moreInfoButtonStyle = {
    color: azurColor,
};

export const moreInfoUndoStyle = {
    fontSize      : 50,
    paddingTop    : 10,
    paddingRight  : 10,
    paddingBottom : 10,
    color         : greyColor,
};

export const moreInfoLabelStyle = {
    textAlign : 'center' as 'center',
    color     : lighterMarineColor,
};

export const disabledLabelStyle = {
    position        : 'absolute' as 'absolute',
    top             : '50%',
    left            : '50%',
    transform       : 'translate(-50%, -50%)',
    backgroundColor : pureWhite,
    pointerEvents   : 'none' as 'none',
    padding         : spaceMicro,
    height          : 'auto' as 'auto',
};
